export enum FONTS {
  ROBOTO_REGULAR = 'roboto-regular',
  ROBOTO_BOLD = 'roboto-bold',
  MULI_REGULAR = 'muli-regular',
  MULI_BOLD = 'muli-bold'
}
